// トップの T シャツ 2 種類の入口: 色の丸を触るとカードの写真がその色に、カメレオンも同じ色に。画面に入ったら丸が順に出る
(() => {
  // 生地色（yj-pdp.js と同じ値）
  const HEX = {
    'White': '#f4f4f1', 'Ivory': '#f3ecd6', 'Sandstone': '#958c71', 'Grey': '#95948f', 'Pepper': '#55524f', 'Black': '#1f1f20',
    'Butter': '#f6dfa4', 'Mustard': '#f2b95e', 'Terracotta': '#ee9268', 'Brick': '#8b4b55', 'Chambray': '#d4ecf7', 'Blue Jean': '#717f8e',
    'True Navy': '#232f4b', 'Blue Spruce': '#4e6253', 'Moss': '#6c7155', 'Blossom': '#f7d6e0',
    'Sand': '#d2c1a6', 'Light Blue': '#a2c0e0', 'Indigo Blue': '#4f6f93', 'Forest Green': '#243d24', 'Military Green': '#524f3f',
    'Navy': '#19263a', 'Maroon': '#6c182d', 'Light Pink': '#f6b6cd',
    // Printstar 00085-CVT（日本版・Printful の color_code）
    'Smoke black': '#2e2c29', 'Purple': '#59276e', 'Burgundy': '#87202c', 'Army Green': '#45402a', 'Red': '#e01d24', 'Charcoal': '#57504e',
    'Heather Gray': '#c9c6c5', 'Heather gray': '#c9c6c5', 'Natural': '#f8eace', 'Heather Oatmeal': '#fcfcf5', 'Mint Green': '#57ebbe',
  };
  const order = Object.keys(HEX);
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  for (const card of document.querySelectorAll('.good')) {
    const box = card.querySelector('.good__colors'), count = box.querySelector('.good__count');
    const sws = [...box.querySelectorAll('.gsw')].sort((a, b) => order.indexOf(a.dataset.color) - order.indexOf(b.dataset.color));
    sws.forEach((b, n) => { b.style.setProperty('--c', HEX[b.dataset.color] || '#ccc'); b.style.setProperty('--n', n); box.insertBefore(b, count); });
    const imgs = card.querySelectorAll('.good__photo'), links = card.querySelectorAll('.good__img, .good__name, .good__cta');
    let flip = 0, cur = null, tok = 0;
    const pick = b => {
      if (cur === b) return;
      cur?.setAttribute('aria-checked', 'false'); b.setAttribute('aria-checked', 'true'); cur = b;
      card.style.setProperty('--cham', HEX[b.dataset.color]);
      // 写真は 2 枚を交互に使う。続けて押したときは最後に押した色だけを出す（古い読み込みが後から終わっても切り替えない。
      // スマホで速く押すと前の色の load が遅れて届き、写真が 1 つ前の色に戻っていた。10/26）
      const t = ++tok, next = imgs[flip ^ 1];
      const go = () => { if (t !== tok) return; next.classList.add('is-on'); imgs[flip].classList.remove('is-on'); flip ^= 1; };
      next.src = b.dataset.img;
      (next.decode ? next.decode() : Promise.reject()).then(go, () => { if (next.complete && next.naturalWidth && next.src === b.dataset.img) go(); else next.addEventListener('load', go, { once: true }); });
      for (const a of links) a.href = b.dataset.href;
      const peek = card.querySelector('.peek__cham');
      if (peek && !reduce.matches) { peek.classList.remove('is-jelly'); void peek.offsetWidth; peek.classList.add('is-jelly'); }
    };
    for (const b of sws) {
      b.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') pick(b); });
      b.addEventListener('click', () => pick(b));
      b.addEventListener('focus', () => pick(b));
    }
    // 写真は触った色だけ読む（先読みしない）。画面に入ったら丸を順に出し、カメレオンが顔を出す
    new IntersectionObserver(([e], io) => { if (e.isIntersecting) { card.classList.add('is-in'); io.disconnect(); } }, { threshold: .25 }).observe(card);
  }
})();

